export default __webpack_public_path__ + "static/media/download.c009bde9.svg";